// src/components/store/sections/gallery/GalleryV90ClayframesFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV90ClayframesFuchsiaGlow(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={90}
      archKey="clay_frames"
      archLabel="3D Clay Recessed Frames"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
